import React, { useState } from 'react';
import { DragDropContext, Draggable, Droppable } from '@hello-pangea/dnd';
import Box from '@material-ui/core/Box';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Typography from '@material-ui/core/Typography';
import DragIndicatorIcon from '@material-ui/icons/DragIndicator';
import strings from 'strings';
import FPButtonBuilder from 'UI/components/molecules/FPButtonBuilder';
import FPDrawer from 'UI/components/templates/FPDrawer/FPDrawer';

import { useTabStyles } from './TabsView.styled';

const COPIES = strings.inventoryProfiles.sections.tabs.organize;

const reorder = ({ list, startIndex, endIndex }) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);
  return result;
};

export const OrganizeTabsDrawer = ({ onClose, onSave, open = true, subheader, tabs }) => {
  const classes = useTabStyles();
  const [orderedTabs, setOrderedTabs] = useState(tabs);

  const onDragEnd = result => {
    if (!result.destination) return;
    const reordered = reorder({
      list: orderedTabs,
      startIndex: result.source.index,
      endIndex: result.destination.index
    });
    setOrderedTabs(reordered);
  };

  const handleSaveOrder = () => {
    onSave(orderedTabs);
  };

  const buttonDefinitions = [
    {
      props: {
        text: strings.shared.ui.close,
        variant: 'outlined',
        onClick: onClose
      },
      GridItemProps: {
        md: 3
      }
    },
    {
      props: {
        initialText: strings.shared.ui.save,
        onClick: handleSaveOrder,
        variant: 'contained'
      },
      GridItemProps: {
        md: 3
      },
      mode: 'save'
    }
  ];

  return (
    <FPDrawer
      CardHeaderProps={{ title: COPIES.title, subheader }}
      FPDrawerProps={{ 'aria-label': COPIES.title, open }}
      onClose={onClose}
      contentContainerClassName={classes.organizeDrawer}
      footer={
        <FPButtonBuilder
          GridContainerProps={{ spacing: 2 }}
          buttonDefinitions={buttonDefinitions}
        />
      }
    >
      <Typography>{COPIES.headerText}</Typography>
      <DragDropContext onDragEnd={onDragEnd}>
        <Droppable droppableId="tabs-sorter">
          {provided => (
            <List ref={provided.innerRef} {...provided.droppableProps}>
              {orderedTabs.map((tabItem, index) => (
                <Draggable key={String(tabItem.id)} draggableId={String(tabItem.id)} index={index}>
                  {(prov, snapshot) => (
                    <ListItem
                      ref={prov.innerRef}
                      {...prov.draggableProps}
                      className={classes.organizeDrawerItem}
                      style={{
                        ...prov.draggableProps.style,
                        boxShadow: snapshot.isDragging ? '0 1px 4px rgba(0,0,0,0.12)' : undefined
                      }}
                    >
                      <Box
                        component="div"
                        display="flex"
                        alignItems="center"
                        marginRight={1}
                        {...prov.dragHandleProps}
                      >
                        <DragIndicatorIcon />
                      </Box>
                      <ListItemText primary={tabItem.label} />
                    </ListItem>
                  )}
                </Draggable>
              ))}

              {provided.placeholder}
            </List>
          )}
        </Droppable>
      </DragDropContext>
    </FPDrawer>
  );
};
